import { render, staticRenderFns } from "./serviceOrderDetail.vue?vue&type=template&id=7a4fc4b9&scoped=true&"
import script from "./serviceOrderDetail.vue?vue&type=script&lang=ts&"
export * from "./serviceOrderDetail.vue?vue&type=script&lang=ts&"
import style0 from "./serviceOrderDetail.vue?vue&type=style&index=0&id=7a4fc4b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4fc4b9",
  null
  
)

export default component.exports